<!-- eslint-disable -->
<template lang="pug">
		span.help-text(
				:class=`{
		      	'help-text--error': error,
		    }`,
		)
				slot
</template>

<script>
    /*eslint-disable*/
    /**
    * Help text under form group element.
    */
    export default {
		    name: 'HelpText',
		    status: 'ready',
		    release: '1.0.0',
		    props: {
		        /**
		        * The error state of image input.
		        */
		        error: {
				        type: Boolean,
				        default: false
		        }
		    }
    }
</script>

<style lang="scss" scoped>
		.help-text {
				font-weight: 500;
				font-size: 12px;
				line-height: 25px;
				color: rgba($x-color-black, $opacity-muted-text);

				&--error {
						color: $hsl-color-red-62;
				}
		}
</style>
